/* Break grid — tab filtering + add-to-cart (then redirect to cart, like the reference site).
   Progressive enhancement: each button is a real <form action="/cart/add">, so it still
   works with JS disabled (native POST also lands on the cart page). */
(function () {
  'use strict';

  function initGrid(grid) {
    initTabs(grid);
    initForms(grid);
    initGallery(grid);
    initVariantTable(grid);
  }

  /* ---- Break product page: thumbnail → main-image swap ---- */
  function initGallery(grid) {
    var gallery = grid.querySelector('[data-break-gallery]');
    var main = grid.querySelector('[data-break-main]');
    if (!gallery || !main) return;
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));

    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (!thumb) return;
      var full = thumb.getAttribute('data-full');
      if (full) {
        main.src = full;
        main.removeAttribute('srcset');
      }
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    });
  }

  /* ---- PYT/PYL table: enable the CTA once a team/letter row is chosen ---- */
  function initVariantTable(grid) {
    grid.addEventListener('change', function (e) {
      var radio = e.target.closest('[data-variant-radio]');
      if (!radio) return;
      var form = radio.closest('[data-break-form]');
      if (!form) return;

      var title = radio.getAttribute('data-variant-title') || '';
      var price = radio.getAttribute('data-variant-price') || '';

      var btn = form.querySelector('[data-add-btn]');
      if (btn) {
        btn.disabled = false;
        btn.setAttribute('aria-disabled', 'false');
        var buyLabel = btn.getAttribute('data-label-buy');
        if (buyLabel) btn.textContent = price ? buyLabel + ' — ' + price : buyLabel;
      }

      var summary = form.querySelector('[data-variant-summary]');
      if (summary) {
        var nameEl = summary.querySelector('[data-summary-name]');
        var priceEl = summary.querySelector('[data-summary-price]');
        if (nameEl) nameEl.textContent = title;
        if (priceEl) priceEl.textContent = price;
        summary.hidden = false;
      }

      var rows = form.querySelectorAll('[data-variant-row]');
      Array.prototype.forEach.call(rows, function (row) {
        row.classList.toggle('is-selected', row.contains(radio));
      });
    });
  }

  /* ---- Category tabs ---- */
  function initTabs(grid) {
    var tabBar = grid.querySelector('[data-break-tabs]');
    if (!tabBar) return;
    var tabs = Array.prototype.slice.call(tabBar.querySelectorAll('.break-grid__tab'));
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-break-card]'));
    var noneMsg = grid.querySelector('[data-break-none]');

    tabBar.addEventListener('click', function (e) {
      var tab = e.target.closest('.break-grid__tab');
      if (!tab) return;
      var filter = (tab.getAttribute('data-filter') || 'all').toLowerCase();

      tabs.forEach(function (t) {
        var active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      var visible = 0;
      cards.forEach(function (card) {
        var cat = (card.getAttribute('data-category') || '').toLowerCase();
        var show = filter === 'all' || cat === filter || (filter === 'other' && cat === '');
        card.hidden = !show;
        if (show) visible++;
      });

      if (noneMsg) noneMsg.hidden = visible !== 0;
    });
  }

  /* ---- Add to cart, then go to the cart page ---- */
  function initForms(grid) {
    grid.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-break-form]');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('[data-add-btn]');
      if (!btn || btn.disabled) return;

      var original = btn.innerHTML;
      btn.disabled = true;
      flash(btn, 'Adding…');

      var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          window.location.href = root + 'cart';
        })
        .catch(function () {
          flash(btn, 'Unavailable');
          setTimeout(function () {
            btn.disabled = false;
            btn.innerHTML = original;
          }, 1500);
        });
    });
  }

  function flash(btn, text) {
    var span = document.createElement('span');
    span.className = 'break-card__btn-label';
    span.textContent = text;
    btn.replaceChildren(span);
  }

  function boot() {
    document.querySelectorAll('[data-break-grid]').forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
